import * as React from "react";
import { useState } from "react";
import api from "../../../../api";
import TimeAndDepartmentManager from "../../../base/TimeAndDepartmentManager";
import "./style.css";
import { DefaultButton, Dialog, DialogFooter, PrimaryButton } from "@fluentui/react";

interface ComplaintDialogProps {
    order: Order;
    departments: Department[];
    user: UserInformation;
}
let doubleClickController = false;
const CopyCurrentOrder: React.FunctionComponent<ComplaintDialogProps> = props => {
    const [hideDialog, setHideDialog] = useState(true);
    const [timeAndPlace, setTimeAndPlace] = useState<TimeAndPlace>(props.order.timeAndPlace);
    const [internalComment, setInternalComment] = useState<string>("");

    const updateTimeAndPlace = (timeAndPlaceUpdate: Partial<TimeAndPlace>) => setTimeAndPlace({ ...timeAndPlace, ...timeAndPlaceUpdate });

    const toggleDialog = () => setHideDialog(!hideDialog);
      
    const createOrder = async ( timeAndPlaceResult: TimeAndPlace = timeAndPlace ) => {
        const { orderId } = props.order.additionalData;
        const model: CopyOrderModel = {
            internalComment,
            timeAndPlace: timeAndPlaceResult
        };
       
        if (orderId) {
            if (!doubleClickController) {
                doubleClickController = true;
                const newOrder = await api.OrderAPI.copyOrder( orderId, model );
                window.location.href = `/worksheet/${newOrder.additionalData.orderId}`;
            }
        }
    };
    const updateAdditionalDataObject = (additionalData: AdditionalData) => setInternalComment(additionalData.internalOrderComment);
       
    const onCreateComplaintClick = async () => {
        if (timeAndPlace.timeSlotId && timeAndPlace.from && timeAndPlace.to) {
            await createOrder();
        } else {
            alert("Du mangler at vælge en tid");
        }
    };

    const updateMobileServiceProduct = () => {};

    if (!props.order.additionalData.orderId) {
        return null;
    }

    return (
        <>
            <DefaultButton onClick={toggleDialog}>
                Opret ny ordre på baggrund af denne
            </DefaultButton>
            <Dialog
                minWidth={800}
                hidden={hideDialog}
                onDismiss={toggleDialog}
                title="Kopier Ordre"
            >
                <TimeAndDepartmentManager
                    updateTimeOnCashDepartmentChange={false}
                    orderItems={props.order.items}
                    timeAndPlace={timeAndPlace}
                    additionalData={props.order.additionalData}
                    car={props.order.car}
                    departments={props.departments}
                    debitor={props.order.debitor}
                    orderType={props.order.additionalData.orderType}
                    updateTimeAndPlace={updateTimeAndPlace}
                    updateAdditionalData={updateAdditionalDataObject}
                    updateMobileServiceProduct={updateMobileServiceProduct}
                />
                <DialogFooter>
                    <DefaultButton onClick={toggleDialog} text={"Luk"} />
                    <PrimaryButton
                        onClick={onCreateComplaintClick}
                        text={"Kopier Ordre"}
                    />
                </DialogFooter>
            </Dialog>
        </>
    );
};

export default CopyCurrentOrder;
